import { useNavigate } from "react-router-dom";
import Register from "@/components/Forms/Register";

export default function Signup() {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen overflow-hidden">
      <Register onBackToSignInClick={() => navigate("/login")} />
    </div>
  );
}
